export const versoes = [
    {
        versao: "26.10.22.1703",
        novidades: [
            "Novo Dashboard organizado por módulo (Gestão Acadêmica, Retenção, Financeiro e Captação), com um painel de indicadores e gráficos para cada relatório do menu, filtros e escolha de polos. Painéis disponíveis: Alunos, Aniversariantes, Dependências, Documentos Não Entregues e Relatório de Notas; Acesso ao AVA, Atividades e Solicitações de Evasão; Parcelas Gerais, Parcelas em Aberto e Parcelas Baixadas; Inscrições Graduação, Inscrições Pós e Oferta de Cursos.",
            "Parcelas em Aberto e Parcelas Baixadas no Dashboard são atualizadas uma vez por dia, e a tela mostra o horário da última atualização.",
        ],
        ajustes: [
            "As opções dos filtros dos relatórios carregam mais rápido.",
            { texto: "As rotinas que fazem muita leitura no banco agora rodam em fila, uma de cada vez, inclusive as execuções manuais.", somenteMaster: true },
            "O aviso de nova versão foi redesenhado e aparece uma única vez a cada atualização do sistema.",
            "A página de Versões ficou mais compacta: cada versão abre e fecha, e a versão atual aparece em destaque.",
        ],
        correcoes: [
            "Relatório de Notas: as notas de alunos com mais de um ingresso deixaram de ser contadas em dobro.",
            "Relatório de Inscrições Graduação: as inscrições de alunos com mais de um registro deixaram de aparecer repetidas, e a situação acadêmica mostra todas as situações do aluno.",
            { texto: "Rotinas: as janelas de execução e de detalhes voltaram a fechar pelo X e clicando fora, sem precisar recarregar a página.", somenteMaster: true },
            { texto: "Telemetria: a consolidação deixou de falhar quando alguém fica mais de 16 minutos numa mesma tela.", somenteMaster: true },
            "O sistema deixou de desconectar o usuário a cada 24 horas: enquanto estiver em uso, a sessão é renovada automaticamente.",
        ],
    },
    {
        versao: "26.10.14.1600",
        novidades: [
            "Cadastro de usuários: nova permissão \"Inscrições Pós\" no módulo Captação, que libera o relatório de Inscrições Pós e o bloco de Pós no card de Captação da tela inicial.",
        ],
        ajustes: [],
        correcoes: [
            "Tela inicial: o card de Captação deixou de exibir erro para usuários de polo.",
        ],
    },
    {
        versao: "26.10.14.1548",
        novidades: [
            { texto: "Nova tela Rotinas (Master): lista tudo o que o sistema executa sozinho, com situação de cada rotina, última e próxima execução, histórico com saída e erros, execução manual com parâmetros e pausa/reativação.", somenteMaster: true },
            { texto: "Aviso na tela inicial (só para o master) quando o agendador para ou alguma rotina falha ou atrasa.", somenteMaster: true },
        ],
        ajustes: [],
        correcoes: [],
    },
    {
        versao: "26.10.14",
        novidades: [
            { texto: "Nova tela Analytics (Master): mostra como o sistema está sendo usado e onde ele está lento, com indicadores, gráficos e listas detalhadas. As abas são Visão geral, Uso das telas, Performance e Erros, e há comparação de antes e depois de cada versão.", somenteMaster: true },
        ],
        ajustes: [
            { texto: "O registro de acessos passou a guardar também o tempo gasto em consultas ao banco e não atrasa mais a resposta das telas.", somenteMaster: true },
            { texto: "O Relatório de Acessos continua mostrando o histórico completo mesmo depois que os registros detalhados mais antigos forem arquivados.", somenteMaster: true },
        ],
        correcoes: [
            { texto: "Respostas de erro fora do padrão deixaram de impedir o registro do acesso.", somenteMaster: true },
        ],
    },
    {
        versao: "26.10.08",
        novidades: [
            "A tela inicial foi reformulada: agora mostra um card por módulo (Retenção, Financeiro, Matrículas, Captação e Aniversariantes), com o número mais importante em destaque e atalhos que abrem o relatório correspondente já filtrado.",
            "Novo Relatório de Acessos (Master): indicadores de uso do sistema por período, evolução ao longo do tempo, rankings de polos, usuários e telas mais acessadas e painel de fidelização.",
            "A tela de Alunos (Gestão Acadêmica) ganhou um painel analítico com indicadores e gráficos da base consultada.",
            "A ficha do aluno ganhou novo cabeçalho com a foto do AVA (ou as iniciais) e indicadores rápidos: último acesso ao AVA, parcelas em aberto, aproveitamento e matrícula.",
        ],
        ajustes: [
            "Os filtros foram padronizados em Alunos, Oferta de Cursos, Inscrições (Graduação e Pós), Relatório de Notas, Relatório de Acessos, Solicitações de Evasão, Atividades, Acesso ao AVA e Parcelas (Gerais, em Aberto e Baixadas): mesmo painel, filtros ativos em destaque e atalho para remover cada um.",
            "Aniversariantes: o período padrão passa a ser \"Hoje\" e o seletor de período foi padronizado.",
            "A busca de aluno foi redesenhada, com campo de busca central e cartão de resultado mais claro.",
            "O título das páginas ficou maior, para facilitar a leitura.",
            "A tela de login não exibe mais o aviso sobre acesso via CPF.",
        ],
        correcoes: [
            "Solicitações de Evasão: o filtro por data passa a incluir o dia final inteiro, e agora é possível filtrar apenas pelo status.",
        ]
    },
    {
        versao: "26.09.16",
        novidades: [
            "A tela de Alunos (Gestão Acadêmica) foi repaginada: barra de filtros ativos com atalhos para remover cada filtro, tabela com avatar e e-mail do aluno, situação em destaque colorido, menu de ações por linha (Abrir), escolha de colunas visíveis e busca/exportação aprimoradas.",
        ],
        ajustes: [
            "Na tela de Alunos (Gestão Acadêmica), quando a consulta não retorna resultados, agora é exibida a tabela com os cabeçalhos e a mensagem 'Nenhum registro encontrado', em vez de um espaço em branco.",
        ],
        correcoes: [
        ]
    },
    {
        versao: "26.09.15",
        novidades: [
        ],
        ajustes: [
        ],
        correcoes: [
            "Corrigido um erro na tela de Alunos (Gestão Acadêmica) que, em alguns filtros, interrompia a consulta com a mensagem 'InternalServerError'. A comunicação com a base foi ajustada e as consultas de Graduação e Pós voltaram a funcionar normalmente.",
        ]
    },
    {
        versao: "26.09.11",
        novidades: [
            "A tela de Alunos (Gestão Acadêmica) agora separa Graduação e Pós-Graduação e permite filtrar a base por período de ingresso, matrícula, aceite e pagamento — útil para análises de safra (ingresso e evasão).",
        ],
        ajustes: [
            "O painel de filtros da tela de Alunos foi redesenhado: seletor de modalidade, filtros em colunas, contador de filtros ativos e carregamento com esqueleto.",
            "Os relatórios em tabela passam a ocultar automaticamente as colunas que ficam sem dados no resultado.",
        ],
        correcoes: [
        ]
    },
    {
        versao: "26.08.17",
        novidades: [
        ],
        ajustes: [
            "O menu lateral agora lembra se você o deixou minimizado, mantendo sua preferência ao atualizar a página.",
        ],
        correcoes: [
        ]
    },
    {
        versao: "26.08.13",
        novidades: [
        ],
        ajustes: [
            "O relatório de Parcelas em Aberto ganhou um resumo em cards, total geral, valores em R$ nas tabelas e filtro por período de competência (De/Até).",
            "A tela inicial e o relatório de Parcelas em Aberto agora carregam de forma mais suave, com um esqueleto de conteúdo no lugar do antigo indicador de carregamento.",
        ],
        correcoes: [
        ]
    },
    {
        versao: "26.08.03",
        novidades: [
            "Novo Relatório de Notas na Gestão Acadêmica: acompanhe o desempenho por indicadores (KPIs), gráficos e resumo por grupos, com detalhamento até o aluno.",
        ],
        ajustes: [
        ],
        correcoes: [
        ]
    },
    {
        versao: "26.07.31",
        novidades: [
            "A tela de Usuários ganhou cards de resumo (Todos, Master e Desativados) que filtram a lista ao clicar.",
        ],
        ajustes: [
            "O avatar do usuário agora mostra as iniciais quando não há foto, com a opção de remover a foto.",
            "Os itens do menu lateral passaram a ficar em ordem alfabética dentro de cada módulo.",
        ],
        correcoes: [
        ]
    },
    {
        versao: "26.07.24",
        novidades: [
        ],
        ajustes: [
            "O Log de Acesso foi reorganizado: filtros reunidos em um card e resultado exibido após a busca, evitando buscas repetidas.",
        ],
        correcoes: [
        ]
    },
    {
        versao: "26.07.21",
        novidades: [
        ],
        ajustes: [
            "O cadastro de Polos foi redesenhado: edição da descrição do polo, cards de estatísticas que filtram por status e visual de tabela padronizado.",
        ],
        correcoes: [
        ]
    },
    {
        versao: "26.07.16",
        novidades: [
        ],
        ajustes: [
            "A tela do Aluno foi renovada: seletor de curso com rótulo e um novo card de dados pessoais com banner e avatar.",
        ],
        correcoes: [
        ]
    },
    {
        versao: "26.06.05",
        novidades: [
            "Busca de Alunos repaginada: novo card com avatar, campos copiáveis, alternância entre lista e grade (com sua preferência salva), rolagem infinita e botão para selecionar o aluno direto no card.",
        ],
        ajustes: [
        ],
        correcoes: [
        ]
    },
    {
        versao: "25.09.25",
        novidades: [
            "Relatório de parcelas em aberto conta com o filtro de tipo de vencimento."
        ],
        ajustes: [
            
        ],
        correcoes: [
            'Corrigido ordenação e datas e valores monetários na tabela.'
        ]
    },
    {
        versao: "25.04.29",
        novidades: [
        ],
        ajustes: [
            "As informações de polo de prática e polo de captação estão sendo exibidas novamente."
        ],
        correcoes: [
            "Corrigido ao gerar relatório de Captação com caracteres especiais.",
        ]
    },
    {
        versao: "25.04.16",
        novidades: [
            "Implantamos um sistema de notificações. Em breve integração com outros módulos como Retenção e Evasão.",
            "Adicionamos um novo dashboard de Alunos por Etapa, proporcionando uma visão clara do progresso acadêmico em cada fase.",
            "Incluímos um botão para exportação de relatórios em formato XLSX.",
        ],
        ajustes: [
            "Refatoramos o módulo de Aluno, tornando o código mais organizado e a experiência de uso mais fluida e eficiente.",
            "Atualizamos os relatórios de Alunos e o Dashboard de Parcelas Gerais com melhorias visuais e maior precisão nos dados apresentados.",
            "Atualizamos a configuração de timezone na base de usuários, assegurando maior consistência nos registros de data e hora.",
        ],
        correcoes: [
            "Corrigimos um problema que afetava a paginação de listas quando um modal era aberto, garantindo uma navegação fluida entre páginas.",
            "Ajustamos falhas na exibição e marcação de leitura de notificações.",
        ]
    },
    {
        versao: '24.08.29',
        novidades: [],
        ajustes: [
            'O filtro do relatório de Inscrições no módulo de Captação está mais poderoso e intuitivo. Explore opções aprimoradas para refinar suas buscas e obtenha insights mais precisos com facilidade.',
            'O relatório de Aniversariantes no módulo de Gestão Acadêmica foi atualizado para incluir número de telefone do aluno. Fique ainda mais conectado e facilite o contato com os aniversariantes diretamente do relatório!',
        ],
        correcoes: [
            'Resolvemos um erro que impedia a filtragem correta dos campos no relatório de Inscrições do módulo de Captação. Agora você pode filtrar os dados com precisão e eficiência.',
        ],
    },
]

// Cada item é um texto (todos veem) ou { texto, somenteMaster: true } (só o
// master vê). Devolve as versões com os itens visíveis para o usuário, já como
// texto, sem as versões que ficaram vazias para ele.
export function versoesVisiveis(user) {
    const master = !!(user && user.master);
    const visiveis = (itens) => (itens || [])
        .filter((item) => typeof item === "string" || master || !item.somenteMaster)
        .map((item) => (typeof item === "string" ? item : item.texto));

    return versoes
        .map((v) => ({
            ...v,
            novidades: visiveis(v.novidades),
            ajustes: visiveis(v.ajustes),
            correcoes: visiveis(v.correcoes),
        }))
        .filter((v) => v.novidades.length + v.ajustes.length + v.correcoes.length > 0);
}
